import { http } from '@/lib/ats-https';
import { convertToFormData } from '@/lib/util';
// import { http as oldHttp } from '@/lib/http';

async function safeCall(call: Promise<unknown>): Promise<unknown> {
  try {
    const response = (await call) as any;
    if (response?.errors?.length) return { error: response.errors };
    return response?.data ?? null;
  } catch (err: any) {
    const errors = err?.response?.data?.errors;
    if (Array.isArray(errors) && errors.length) return { error: errors };
    throw err;
  }
}

// main api calls to get the overall data
const getInterviewPlan = async ({ stageId, stageActivityId, contactId }) => {
  let url = `ats_interviews/new?ats_job_stage_id=${stageId}`;

  if (stageActivityId) {
    url += `&ats_job_stage_action_id=${stageActivityId}`;
  }

  if (contactId) {
    url += `&contact_id=${encodeURIComponent(contactId)}`;
  }
  const { data } = await http.get(url);
  return data;
};

// getInterviewDetails will fetch the  interview edit details
const getInterviewDetails = async (interviewId) => {
  const { data } = await http.get(`ats_interviews/${interviewId}`);
  return data;
};

const getCalendarInviteTemplates = async ({
  channel = null,
  category = null,
}) => {
  let apiURL =
    'ats_comm_templates?filter_by[channel]=calendar_invite&items=200';
  if (channel) apiURL += `&filter_by[category][]=${channel}`;
  if (category) apiURL += `&filter_by[category][]=${category}`;
  const { data } = await http.get(apiURL);
  return data;
};

const getDefaultScorecard = ({ payload }) =>
  safeCall(http.get('/ats_scorecards/default_template', payload));

const createInterview = (payload) =>
  safeCall(http.post('/ats_interviews', payload));

const updateInterview = (payload, interviewId) =>
  safeCall(http.put(`/ats_interviews/${interviewId}`, payload));

const createSelfSchedule = (payload) =>
  safeCall(http.post(`/ats_schedules`, convertToFormData(payload)));

const getSelfScheduleDetails = async (scheduleId) => {
  const response = (await http.get(`/ats_schedules/${scheduleId}`)) as any;
  if (response?.['errors']?.length) {
    return { error: response?.['errors'] };
  }
  return response?.['data'];
};

const updateSelfSchedule = (payload, scheduleId) =>
  safeCall(
    http.put(`/ats_schedules/${scheduleId}`, convertToFormData(payload))
  );

const createBulkSelfSchedule = (payload) => {
  delete payload.candidate_id;
  delete payload.contact_id;
  return safeCall(http.post('/ats_schedules/bulk', convertToFormData(payload)));
};

const getStageActionDetails = async (payload) => {
  const {
    selectedApplicationIds,
    unSelectedApplicationIds,
    jobStageId,
    jobStatus,
  } = payload;
  const { data } = await http.get(`/ats_applications/bulk/interview_status`, {
    params: {
      ats_application_ids: selectedApplicationIds,
      ats_job_stage_id: jobStageId,
      bulk_selected_ats_job_stage_ids: unSelectedApplicationIds && [jobStageId],
      bulk_selected_application_statuses: unSelectedApplicationIds && [
        jobStatus,
      ],
      bulk_exempted_application_ids: unSelectedApplicationIds,
    },
  });
  return data;
};

const getInterviewPools = async () => {
  // Get interview pools used for schedule all feature
  const { data } = await http.get('/user_groups?type=ats_interviewer_pool');
  return data;
};

export const ScheduleAPI = {
  getInterviewPlan,
  getCalendarInviteTemplates,
  getDefaultScorecard,
  getInterviewDetails,
  createInterview,
  updateInterview,
  createSelfSchedule,
  getSelfScheduleDetails,
  updateSelfSchedule,
  createBulkSelfSchedule,
  getStageActionDetails,
  getInterviewPools,
};
